<template>
    <div class="all-container" v-if="url">
        <div :class="{item:!fullScreenId, full:fullScreenId==='0', hidden: fullScreenId&&fullScreenId!=='0' }">
            <iframe
                :style="{border: 'none'}"
                border="0"
                width="100%"
                height="100%"
                :src="url+'0'"
            />
            <div class="icon-full" @click="handelFullScreen('0')">
                <i class="el-icon-full-screen"></i>
            </div>
        </div>
        <div :class="{item:!fullScreenId, full:fullScreenId==='1', hidden: fullScreenId&&fullScreenId!=='1' }">
            <iframe
                :style="{border: 'none'}"
                border="0"
                width="100%"
                height="100%"
                :src="url+'1'"
            />
            <div class="icon-full" @click="handelFullScreen('1')">
                <i class="el-icon-full-screen"></i>
            </div>
        </div>
        <div :class="{item:!fullScreenId, full:fullScreenId==='2', hidden: fullScreenId&&fullScreenId!=='2' }">
            <iframe
                :style="{border: 'none'}"
                border="0"
                width="100%"
                height="100%"
                :src="url+'2'"
            />
            <div class="icon-full" @click="handelFullScreen('2')">
                <i class="el-icon-full-screen"></i>
            </div>
        </div>
        <div :class="{item:!fullScreenId, full:fullScreenId==='3', hidden: fullScreenId&&fullScreenId!=='3' }">
            <iframe
                :style="{border: 'none'}"
                border="0"
                width="100%"
                height="100%"
                :src="url+'3'"
            />
            <div class="icon-full" @click="handelFullScreen('3')">
                <i class="el-icon-full-screen"></i>
            </div>
        </div>
        <div :class="{item:!fullScreenId, full:fullScreenId==='4', hidden: fullScreenId&&fullScreenId!=='4' }">
            <iframe
                :style="{border: 'none'}"
                border="0"
                width="100%"
                height="100%"
                :src="url+'4'"
            />
            <div class="icon-full" @click="handelFullScreen('4')">
                <i class="el-icon-full-screen"></i>
            </div>
        </div>
        <div :class="{item:!fullScreenId, full:fullScreenId==='5', hidden: fullScreenId&&fullScreenId!=='5' }">
            <iframe
                :style="{border: 'none'}"
                border="0"
                width="100%"
                height="100%"
                :src="url+'5'"
            />
            <div class="icon-full" @click="handelFullScreen('5')">
                <i class="el-icon-full-screen"></i>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "All",
    data() {
        return {
            url: '',
            fullScreenId: ''
        }
    },
    created() {
        this.url = `${window.location.origin}/#/index?menu=`
    },
    methods: {
        handelFullScreen(id) {
            if(this.fullScreenId === id) {
                this.fullScreenId = ''
            } else {
                this.fullScreenId = id
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.all-container {
    position: relative;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-wrap: wrap;
    .item {
        position: relative;
        height: 50%;
        width: 33.33%;
        .icon-full {
            position: absolute;
            right: 24px;
            top: 0;
            width: 100px;
            color: #fff;
            font-size: 26px;
            cursor: pointer;
            text-align: right;
        }
    }
    .full {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        .icon-full {
            position: absolute;
            right: 70px;
            top: 24px;
            width: 100px;
            color: #fff;
            font-size: 30px;
            cursor: pointer;
            text-align: right;
        }
    }
    .hidden {
        visibility: hidden;
    }
}
</style>